import entrata from './entrata.png';
import realpage from './realpage.png';
import yardi from './yardi.png';
import knock from './knock.png';

const logos = {
  entrata,
  realpage,
  yardi,
  knock
};

export default logos;
